export const Text = `
# Welcome to **LensTalk** V1.4!

Thank you for updating LensTalk to V1.4! This version includes feature improvements, bug fixes, and the latest stable security patches.

## Changelog

* **Scan Mode**: LensTalk now supports paper scanning and document reading through your selected camera. Simply say, "Read this out," to hear what's in front of the camera.  
* **Location Permission Fix**: We've resolved the MaxMind GeoLocation Service permission issue, ensuring machine-readable locations are properly converted into human-readable states and cities.  
* **Performance Enhancements**: All DOM manipulations and resource-intensive tasks are now processed in batches, eliminating crashes and improving efficiency.  
* **Camera Switching During Conversations**: Mobile users can now switch between the front and back cameras during a conversation, allowing for flexible visual input.  
* **Audio-Visual Indicator**: A real-time audio-visual indicator is now displayed just below the voice selection dropdown, providing light-based feedback for better accessibility.  
* **Bug Fixes**: Various under-the-hood improvements and stability fixes.  

Thank you for your continued support of LensTalk! We are committed to enhancing this service with new features based on your valuable feedback.  
`;
